// Copyright © 2015-2020 TrampleZone LLC All Rights Reserved

// AboutView Module

define('AboutView',['require','jquery','About','Browser','Utilities'],function (require) {
    'use strict';

    var // Require.js module dependencies
        $ = require('jquery'),
        About = require('About'),
        Browser = require('Browser'),
        Utilities = require('Utilities'),

        // Instance variables
        name = 'AboutView',
        self,
        browser,
        about,
        utilities,
        main,
        aboutTopicDiv,
        aboutTopicSpan,
        aboutDescriptionDiv,
        aboutDescriptionP,
        aboutLinkDiv,
        aboutLinkSpan,
        aboutItemDiv,
        aboutTopics,
        aboutDivMinWidth = 320,
        aboutDivMaxWidth = 600,
        initialized = false,

        // HTML elements
        doc = window.document,
        div = doc.createElement('div'),
        mainDiv = doc.createElement('div'),
        frameDiv = doc.createElement('div'),
        panelDiv = doc.createElement('div'),
        aboutDiv = doc.createElement('div'),
        aboutFrameDiv = doc.createElement('div'),
        aboutTitleDiv = doc.createElement('div'),
        aboutTitleSpan = doc.createElement('span'),
        aboutListDiv = doc.createElement('div'),
        footerDiv = doc.createElement('div'),
        footerSpan = doc.createElement('span');


    // Constructor
    function AboutView () {
        // Preserve instance reference and enforce singleton
        if (typeof self === 'object') { return self; } else { self = this; }

         // Instantiate About and get topics
        about = new About();
        browser = new Browser();
        utilities = new Utilities();
        aboutTopics = about.getAboutTopics();

        // Update about div bounds as window size changes
        this.updateBounds = function () {
            var width = doc.body.clientWidth;
            if (width > aboutDivMaxWidth) {
                width = aboutDivMaxWidth;
            } else {
                if (width < aboutDivMinWidth) {
                    width = aboutDivMinWidth;
                }
            }
            aboutDiv.style.width = width + 'px';
            // Set the min-height based on the height of the panel
            mainDiv.style.minHeight = panelDiv.clientHeight + 'px';
            div.scrollTop = 0;
        };

        // Add about topic to the list
        this.addAboutTopic = function (aboutItem) {
            // Show each About item in a separate div
            if (aboutItem.topic && aboutItem.description) {
                // Add topic
                aboutTopicDiv = doc.createElement('div');
                aboutTopicSpan = doc.createElement('span');
                aboutTopicSpan.innerHTML = aboutItem.topic;

                // Add description
                aboutDescriptionDiv = doc.createElement('div');
                aboutDescriptionP = doc.createElement('p');
                aboutDescriptionP.innerHTML = aboutItem.description;

                // Add optional link
                aboutLinkDiv = doc.createElement('div');
                aboutLinkSpan = doc.createElement('span');
                if (aboutItem.link && aboutItem.link.name && aboutItem.link.url) {
                    aboutLinkDiv.classList.add('show-link');
                    aboutLinkSpan.innerHTML = aboutItem.link.name;
                    utilities.addEventListeners(aboutLinkDiv, function () {
                        browser = new Browser(aboutItem.link.url, '_blank');
                        browser.show();
                    })
                }

                // Assemble
                aboutTopicDiv.appendChild(aboutTopicSpan);
                aboutDescriptionDiv.appendChild(aboutDescriptionP);
                aboutLinkDiv.appendChild(aboutLinkSpan);
                aboutItemDiv = doc.createElement('div');
                aboutItemDiv.appendChild(aboutTopicDiv);
                aboutItemDiv.appendChild(aboutDescriptionDiv);
                aboutItemDiv.appendChild(aboutLinkDiv);

                // Add about to list
                aboutListDiv.appendChild(aboutItemDiv);
            }
        };

        // Update the footer div
        this.updateFooterCount = function (count) {
            footerSpan.innerHTML = 'Enjoy using ' + utilities.getApplicationName() + '!';
        };
    }


    // Public Prototype Methods

    // Initialization
    AboutView.prototype.initialize = function () {
        // Title
        aboutTitleSpan.innerHTML = 'About ' + utilities.getApplicationName();
        aboutTitleDiv.appendChild(aboutTitleSpan);

        // Render about topics
        if (aboutTopics && aboutTopics.length > 0) {
            for (var i=0; i<aboutTopics.length; i++) {
                if (aboutTopics[i]) {
                    this.addAboutTopic(aboutTopics[i]);
                }
            }
        }

        // Update footer count
        this.updateFooterCount(aboutTopics.length);

        // Assemble elements
        aboutFrameDiv.appendChild(aboutTitleDiv);
        aboutFrameDiv.appendChild(aboutListDiv);
        footerDiv.appendChild(footerSpan);
        panelDiv.appendChild(aboutFrameDiv);
        panelDiv.appendChild(footerDiv);
        frameDiv.appendChild(panelDiv);
        aboutDiv.appendChild(frameDiv);
        mainDiv.appendChild(aboutDiv);
        div.appendChild(mainDiv);

        // Add top level id
        div.setAttribute('id', 'about-div');

        initialized = true;
    };

    // Get the initialization status
    AboutView.prototype.isInitialized = function () {
        return initialized;
    };

    // Refresh bounds before displaying
    AboutView.prototype.updateView = function () {
        this.updateBounds();
    };

    // Back button actions
    AboutView.prototype.handleBack = function () {
        $('#about-parent-div').fadeOut(400, function () {
            $('#sizzle-div').fadeIn(400);
        });
    };

    // Get name of class
    AboutView.prototype.getName = function () {
        return name;
    };

    // Get the content div
    AboutView.prototype.getContentDiv = function () {
        return panelDiv;
    }

    // Get the main div container for this view
    AboutView.prototype.getDiv = function () {
        return div;
    };

    // Return Constructor
    return AboutView.prototype.constructor;
});

